    import {
    Component,
    ElementRef,
    ViewEncapsulation,
    ApplicationRef,
    ComponentFactoryResolver,
    Injector,
    Renderer2
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CommonDataService} from "../services/common-data.service";
import {SlickGridComponentBase} from "./slick-grid.component-base";
    import {CommonService} from "../services/common.service";

@Component({
    selector: 'slick-grid',
    template: `
        <div *ngIf="!columns.length && translates" class="no-data-grid"><span>{{ translates.NoSelectedFields }}</span></div>
        <div *ngIf="showNoData && hideGrid" class="no-data-grid"><span>{{ translates.NoData }}</span></div>
        <div *ngIf="showCustomMsg" class="no-data-grid"><span>{{ showCustomMsg }}</span></div>
        <div #grid class="slickgrid" [id]="gridGUID" [class.hide]="showNoData && hideGrid || showCustomMsg"></div>
        <div #gridMenuWrp class="grid-menu-ref" [class.hide]="!showMenu" [style.left.px]="menuPosition.left"
             [style.top.px]="menuPosition.top"></div>
        <div #gridMenu *ngIf="showMenu" class="grid-menu-wrp">
            <column-list [columnId]="columnId" [hiddenColumns]="hiddenColumns" [viewColumns]="viewColumns"
                         [viewWidth]="gridRef.nativeElement.offsetWidth" [frozenColumn]="0"
                         (emitData)="updateColumns($event)" (hide)="showMenu = false"></column-list>
        </div>
        <universal-list *ngIf="showUnList" style="z-index: 110" [GUID]="'123'"
                        [inData]="universalData" [updatePopper]="updatePopper"
                        [wrpRef]="filterBehavior" [addRef]="universalBTN"
                        [bndRef]="filterBoundary"
                        [settings]="universalSettings" [titleKey]="''"
                        [columns]="unColSettings" [inClass]="filtersCssClass"
                        [customSelect]="customSelect"
                        [sorter]="unListSorter"
                        (hide)="applyFilter($event)"></universal-list>`,
    styleUrls: ['./slick-grid.component.css', './cell-colors.css', '../../../node_modules/slickgrid/slick.grid.css', '../../../node_modules/slickgrid/slick-default-theme.css'],
    encapsulation: ViewEncapsulation.None
})
export class SlickGridComponent extends SlickGridComponentBase{
    constructor(
        appRef: ApplicationRef,
        resolver: ComponentFactoryResolver,
        injector: Injector,
        renderer: Renderer2,
        translateService: TranslateService,
        elementRef: ElementRef,
        commonData: CommonDataService,
        common: CommonService
    ){
        super(appRef, resolver, injector, renderer, translateService, elementRef, commonData, common)
    }
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/slick-grid.component.ts